import api from '../client';

/**
 * Service pour le système de crédits par organisation.
 *
 * Le solde appartient à l'organisation : chaque action de l'IA débite un forfait
 * de crédits et, quand le solde atteint 0, les agents sont mis en pause côté
 * serveur. Le dashboard affiche ce solde et le voit évoluer en direct grâce à
 * l'événement socket `credits:updated` (voir CreditsContext).
 */
const creditService = {
  /**
   * Récupérer le solde courant de l'organisation + le barème des actions.
   * @returns {Promise<{ success: boolean, data: { balance: number, actionCosts: Object } }>}
   */
  getBalance: async () => {
    try {
      const response = await api.get('/credits/balance');
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },

  /**
   * Historique paginé des transactions de crédits (pagination serveur).
   * @param {Object} params - { page, limit }
   * @returns {Promise<{ success: boolean, data: Array, pagination: Object }>}
   */
  getTransactions: async (params = {}) => {
    try {
      const response = await api.get('/credits/transactions', { params });
      return response.data;
    } catch (error) {
      throw error.response?.data || error;
    }
  },
};

export default creditService;
